import React from 'react';

const WatermarkOverlay = ({ code }) => {
  if (!code) return null;
  return (
    <div
      data-testid="watermark-overlay"
      className="fixed inset-0 pointer-events-none z-[9999] overflow-hidden select-none"
      style={{ userSelect: 'none', WebkitUserSelect: 'none' }}
      aria-hidden="true"
    >
      <div className="absolute inset-0" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridTemplateRows: 'repeat(4, 1fr)',
        gap: '0px',
        transform: 'rotate(-25deg) scale(1.5)',
        transformOrigin: 'center center',
      }}>
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} className="flex items-center justify-center">
            <span style={{
              fontSize: '18px',
              fontWeight: 700,
              color: 'rgba(0,0,0,0.04)',
              letterSpacing: '4px',
              fontFamily: 'monospace',
              whiteSpace: 'nowrap',
            }}>{code}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WatermarkOverlay;
